<template>
  <div>
    <v-card
        v-if="course && course.id && layout == 'vertical'"
        elevation="1"
        class="pa-1"
        height="100%"
        :href="generateLinkCourse(course.linkSearch)"
    >
      <v-carousel
          :key="componentKey"
          height="200"
          hide-delimiter-background
          :show-arrows="false"
          cycle
          :interval="2000"
       >
        <v-carousel-item
            v-for="(image, i) in course.images"
            :key="i"
        >
          <v-img
              class="carousel-item-img"
              :src="image.path"
              alt=""
              title=""
              height="100%"
              width="100%"
          ></v-img>
        </v-carousel-item>
      </v-carousel>
      <v-card-subtitle class="pb-0 text-left">
        <strong style="text-decoration: none!important;">{{ course.name }}</strong>
      </v-card-subtitle>

      <v-card-text class="mt-2 text-left">
        <p>Carga horária: {{ course.totalHours }} horas</p>
        <p>{{ course.description }}</p>

        <p v-if="student && student.id">Matricula: {{ student.coursesGroupToStudents.map(x => x.numberInscription).join(', ')}}</p>

        <p v-if="student && student.id && courseGroup && courseGroup.id">
          Data de início: {{ parseDate(courseGroup.startDate)}}
        </p>
      </v-card-text>
    </v-card>

    <v-card
        v-if="course && course.id && layout == 'horizontal'"
        elevation="1"
        class="pa-1 d-flex"
        height="90%"
        :href="generateLinkCourse(course.linkSearch)"
    >
      <v-row cols="12" class="ma-0 pa-0">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <v-carousel
              :key="componentKey"
              height="200"
              hide-delimiter-background
              :show-arrows="false"
              cycle
              :interval="5000"
          >
            <v-carousel-item
                v-for="(image, i) in course.images"
                :key="i"
            >
              <div
                  v-if="image.htmlEmbed"
                  v-html="image.htmlEmbed"
              >
              </div>
              <v-img
                  class="carousel-item-img"
                  :src="image.path"
                  alt=""
                  title=""
                  height="100%"
                  width="100%"
                  v-else
              ></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
          <v-card-subtitle class="pb-0">
            <strong style="text-decoration: none!important;">{{ course.name }}</strong>
          </v-card-subtitle>

          <v-card-text class="mt-2">
            <p>Carga horária: {{ course.totalHours }} horas</p>
            <p>{{ course.description }}</p>

            <p v-if="student && student.id">Matricula: {{ student.coursesGroupToStudents.map(x => x.numberInscription).join(', ')}}</p>
            <p v-if="student && student.id && courseGroup && courseGroup.id">
              Data de início: {{ parseDate(courseGroup.startDate)}}
            </p>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import FormatDate from "../../../Utils/FormatDate";
import FormatCurrency from "../../../Utils/FormatCurrency";

export default {
  name: "DetailCourses",
  components: {},
  props: {
    student: {type: Object, default: null},
    courseGroup: {type: Object, default: null},
    course: {type: Object, default: null},
    layout: {type: String, default: 'vertical'},
  },
  async mounted() {

  },

  data: () => ({
    componentKey: 1,
    baseUrl: null,
    path: '',
    periods: [
      {name: "Matutino", value: "0"},
      {name: "Vespertino", value: 1},
      {name: "Noturno", value: 2}
    ],
    levels: [
      {name: "Iniciante", value: "0"},
      {name: "Intermediário", value: 1},
      {name: "Avançado", value: 2}
    ],
    daysOfTheWeek: [
      {name: "Domingo", value: 0},
      {name: "Segunda", value: 1},
      {name: "Terça", value: 2},
      {name: "Quarta", value: 3},
      {name: "Quinta", value: 4},
      {name: "Sexta", value: 5},
      {name: "Sábado", value: 6}
    ],
  }),
  computed: {},

  async created() {
    this.path = this.$route.path
    this.baseUrl = window.location.origin
  },

  watch: {
    'course.id'(){
      if(this.course.videos && this.course.videos.length > 0) {
        this.course.videos.forEach((video) => {
          video.htmlEmbed = video.htmlEmbed
              .replace(/width="\d+"/, 'width="100%"')
              .replace(/height="\d+"/, 'height="500"')
        })
        this.course.images.push(...this.course.videos)
      }
    }
  },
  methods: {
    generateLinkCourse(linkSearch) {
      if (this.path.includes('/cursos/categoria/')) {
        return `${this.baseUrl}/cursos/${linkSearch}`
      }
      return ''
    },
    parseDate(date) {
      return FormatDate.momentDate(date)
    },

    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },

    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },

    formatCurrency(value) {
      return FormatCurrency.formatCurrency(value);
    },

    getDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },

    formatDaysOfTheWeek(daysOfTheWeek) {
      let daysOfTheWeekJson = JSON.parse(daysOfTheWeek)
      if (daysOfTheWeekJson.length === 1) {
        return this.getDaysOfTheWeek(daysOfTheWeekJson)
      }
      daysOfTheWeekJson = daysOfTheWeekJson.sort((x, y) => x - y)
      const isSequential = daysOfTheWeekJson.every((num, i) => i === 0 || num === daysOfTheWeekJson[i - 1] + 1)
      if (isSequential) {
        const [first] = daysOfTheWeekJson
        const last = daysOfTheWeekJson[daysOfTheWeekJson.length - 1]
        return `${this.getDaysOfTheWeek([first])} à ${this.getDaysOfTheWeek([last])}`
      }
      return this.getDaysOfTheWeek(daysOfTheWeekJson)
    },

    async goTo(path, id) {
      await this.$router.push({
        path,
        query: {id, curso_combo: 'curso'}
      });
    },
  },
};
</script>
<style scoped>
.date {
  font-weight: 700;
}
</style>